<template>
<form id="ivr_form" class="border p-2"  @submit.prevent="submit">
<kt-row>
    <kt-col xs="12" class="mb-5">
        <span v-if="ivr.logo == null">
            <img src="/assets/media/image-not-found.png" style="max-width:300px" class="d-block m-auto" :title="$t('label.image_not_found')"/>
        </span>
        <span v-else>
            <img :src="ivr.logo" style="max-width:300px" class="d-block m-auto">
        </span>
    </kt-col>

    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="farsi_name">
                {{ $t('label.farsi_name') }}
            </kt-form-label>
            <kt-form-control
                id="farsi_name"
                name="farsi_name"
                v-model="ivr.farsi_name"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>
    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="english_name">
                {{ $t('label.english_name') }}
            </kt-form-label>
            <kt-form-control
                id="english_name"
                name="english_name"
                v-model="ivr.english_name"
                dir="ltr"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>
    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="ivr_sequence">
                {{ $t('label.gateway_id') }}
            </kt-form-label>
            <kt-form-control
                id="ivr_sequence"
                name="ivr_sequence"
                disabled
                :value="ivr.sequence"
                dir="ltr"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>

    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="telephone">
                {{ $t('label.telephone') }}
            </kt-form-label>
            <kt-form-control
                    dir="ltr"
                    id="telephone"
                    name="telephone"
                    v-model="ivr.phone_number"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>

    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="server_ip">
                {{ $t('label.server_ip') }}
            </kt-form-label>
            <kt-form-control
                    dir="ltr"
                    id="server_ip"
                    name="server_ip"
                    v-model="ivr.server_ip"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>

    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="created_at">
                {{ $t('label.created_at') }}
            </kt-form-label>
            <kt-form-control
                    dir="ltr"
                    id="created_at"
                    name="created_at"
                    disabled
                    :value="ivr.created_at"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>

    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="category_code">
                {{ $t('label.subcategory_code') }}
            </kt-form-label>
            <select
                id="category_code"
                name="category_code"
                v-model="ivr.category_code"
                class="form-control kt-selectpicker"
            >
                <option 
                    v-bind:key="category.key"
                    v-for="category in categories"

                    :value="category.key"
                >
                    {{ category.value }}
                </option>
            </select>
        </kt-form-group>
    </kt-col>
    
    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="address_id">
                {{ $t('label.address') }}
            </kt-form-label>
            <select
                v-if="addresses"
                id="address_id"
                name="address_id"
                v-model="ivr.address_id"
                class="form-control kt-selectpicker"
            >
                <option 
                    v-bind:key="address.id"
                    v-for="address in addresses"
                    :value="address.id"
                >
                    {{ address.address }}
                </option>
            </select>
        </kt-form-group>
    </kt-col>

    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="postal_code">
                {{ $t('label.postal_code') }}
            </kt-form-label>
            <kt-form-control
                id="postal_code"
                name="postal_code"
                disabled
                :value="ivr.postal_code"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>

    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="sheba_id">
                {{ $t('label.sheba_number') }}
            </kt-form-label>
            <select
                id="sheba_id"
                name="sheba_id"
                v-model="ivr.sheba_id"
                class="form-control kt-selectpicker"
            >
                <option 
                    v-bind:key="sheba_number.id"
                    v-for="sheba_number in sheba_numbers"
                    :value="sheba_number.id"
                >
                    {{ sheba_number.number }}
                </option>
            </select>
        </kt-form-group>
    </kt-col>

    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="settlement_variant">
                {{ $t('label.settlement_variant') }}
            </kt-form-label>
            <select
                    id="settlement_variant"
                    name="settlement_variant"
                    v-model="ivr.settlement_variant"
                    class="form-control"
                    disabled
            >
                <option :value="IvrSettlementVariant.MANUAL_SETTLEMENT"
                        v-text="IvrSettlementVariantStr.get(IvrSettlementVariant.MANUAL_SETTLEMENT)">
                </option>
                <option :value="IvrSettlementVariant.CHARGE_WALLET"
                        v-text="IvrSettlementVariantStr.get(IvrSettlementVariant.CHARGE_WALLET)">
                </option>
            </select>
        </kt-form-group>
    </kt-col>
    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="wallet_hashid">
                {{ $t('label.wallet_hashid') }}
            </kt-form-label>
            <kt-form-control
                    dir="ltr"
                    id="wallet_hashid"
                    name="wallet_hashid"
                    v-model="ivr.wallet_hashid"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>

  <kt-col xs="12">
    <kt-form-group>
      <kt-form-label for="bill_code">
        {{ $t('label.bill_code') }}
      </kt-form-label>
        <kt-form-select
                size="3"
                id="bill_generator"
                name="bill_generator"
                v-model="ivr.bill_generator"
        >
            <option value=""></option>
            <option
                    v-bind:key="index"
                    v-for="(bill_generator,index) in ivr.bill_generators"
                    v-bind:value="bill_generator.id"
                    :selected="ivr.bill_generator === bill_generator.id"
            >
                {{ bill_generator.bill_code}}
            </option>
        </kt-form-select>
    </kt-form-group>
  </kt-col>

    <kt-col xs="12">
        <kt-form-action class="mt-4">
            <kt-button 
                class="m-2"
                size="md"
                variant="success"
                type="submit"
                v-bind:wide="true"
                id="submit_btn"
            >
                {{ $t('panel.profile.update.wizard.form.btn.submit') }}
            </kt-button>
        </kt-form-action>
    </kt-col>
</kt-row>
</form>
</template>

<script>
import $ from 'jquery';
import { subcategories } from '@/constants/subcategories';
import { wages } from '@/constants/wageStatus';
import { KTApp } from '@/plugins/core/app';
import { KTUtil } from '@/plugins/core/util';
import { ivrService } from '@/common/api.service';
import { i18n } from '@/plugins/i18n';
import Inputmask from "inputmask";
import { mapGetters } from "vuex";
import {IvrSettlementVariant, IvrSettlementVariantStr} from "@/constants/IvrSettlementVariant";

export default {
    data() {
        return {
            IvrSettlementVariant,
            IvrSettlementVariantStr,
            categories: subcategories,
            'hashid': this.$route.params.hashid,
        };
    },
    props: {
        ivr: {
            required: true,
        }
    },
    computed: {
        ...mapGetters('address', [
            'addresses'
        ]),
        ...mapGetters('shebaNumber', [
            'sheba_numbers'
        ])
    },
    mounted() {
        this.$store.dispatch('shebaNumber/fetchByShopId', {
            'hashid': this.hashid,
            'shop_type': 2
        }).finally(() => {
            Object.keys(this.sheba_numbers).map(key => {
                let number = this.sheba_numbers[key]['number'] == null ? '' : 'IR'+this.sheba_numbers[key]['number'].split('-').join('')
                this.sheba_numbers[key]['number'] = number
            });

            this.$store.dispatch('address/fetchByShopId', {
                'hashid': this.hashid,
                'shop_type': 2
            }).finally(() => {
                this.afterDispatch();
            });
        });
    },
    methods: {
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            });
            document.getElementById('telephone') && Inputmask('099-99999999').mask(document.getElementById('telephone'));
        },
        submit(e) {
            let form = $('#ivr_form')
            let btn = $('#submit_btn')
            form.validate({
                rules: {
                    farsi_name: {
                        required: true,
                    },
                    english_name: {
                        required: true,
                    },
                    category_code: {
                        required: true,
                    },
                    address_id: {
                        required: true,
                    },
                    phone_number: {
                        required: true
                    },
                    sheba_id: {
                        required: true
                    },
                    settlement_variant: {
                        required: true,
                    },
                    wallet_hashid: {
                        required: () => {
                            return this.ivr.settlement_variant === IvrSettlementVariant.CHARGE_WALLET;
                        },
                    },
                }
            });

            if(!form.valid()) {
                return
            }

            KTApp.progress(btn)


            let params = structuredClone(this.$store.getters['ivr/form_data'])
            delete params.bill_generators
            // let form_data = new FormData

            ivrService.updateByAdmin(this.hashid, params).then(response => {
                this.showMsg(form, 'success', response.data.message);
                KTUtil.scrollTop();
            })
            .catch(({response}) => {
                if(response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message)
            })
            .finally(() => {
                KTApp.unprogress(btn)
            })
        },
    }
}
</script>

<style>

</style>